import { yupResolver } from '@hookform/resolvers/yup';
import { IUserRole } from 'types/Auth';
import { passwordMatch } from 'util/auth';
import { validateCPF } from 'validations-br';
import * as Yup from 'yup';

const cpfValidation = Yup.string()
  .required('CPF não pode ficar em branco')
  .test('is-cpf', 'CPF inválido', (value: string | undefined) =>
    validateCPF(value as string)
  );

const passwordValidation = Yup.string().required(
  'A senha não pode ficar em branco'
);

const emaiValidation = Yup.string()
  .required('E-mail não pode ficar em branco')
  .email('E-mail inválido');

const passwordConfirmationValidation = Yup.string()
  .required('A confirmação de senha não pode ficar em branco')
  .oneOf([Yup.ref('password'), null], 'As senhas não conferem');

const passwordStrengthValidation = Yup.string()
  .required('Senha não pode ficar em branco')
  .test(
    'is-valid-password',
    'A senha não atende aos requisitos abaixo',
    (value: string | undefined) => passwordMatch(value as string).isValid
  );

export const loginValidation = Yup.object({
  cpf: cpfValidation,
  password: passwordValidation,
  // captchaToken: Yup.string().required(
  //   'Você precisa confirmar que não é um robô'
  // ),
});

export const partnerLoginValidation = Yup.object({
  email: emaiValidation,
  password: passwordValidation,
  // captchaToken: Yup.string().required(
  //   'Você precisa confirmar que não é um robô'
  // ),
});

export const requestRecoveryPasswordTokenValidation = (role: IUserRole) => {
  if (role === 'partner' || role === 'company') {
    return yupResolver(
      Yup.object({
        email: emaiValidation,
      })
    );
  }

  return yupResolver(
    Yup.object({
      cpf: cpfValidation,
    })
  );
};

export const partnerPreRegistrationValidation = () =>
  yupResolver(
    Yup.object({
      email: emaiValidation,
      password: passwordStrengthValidation,
      passwordConfirmation: passwordConfirmationValidation,
      acceptTerms: Yup.object().shape({
        isAccepted: Yup.boolean().oneOf(
          [true],
          'Você precisa aceitar os termos acima'
        ),
      }),
    })
  );

export const recoveryPasswordValidation = Yup.object({
  password: passwordStrengthValidation,
  passwordConfirmation: passwordConfirmationValidation,
});
